<template>
    <a-card :bordered="false" class="header-solid h-full" :bodyStyle="{ padding: '20px' }">
        <a-form class="mb-20" layout="inline" :form="dataForm" @submit="getDataList">
            <a-form-item label="客户名称">
                <a-input v-model="dataForm.customer_name" placeholder="客户姓名" />
            </a-form-item>
            <a-form-item label="项目名称">
                <a-input v-model="dataForm.project_name" placeholder="项目名称" />
            </a-form-item>
            <a-form-item label="指定项目筛选">
                <el-cascader :props="{ checkStrictly: true }" :options="supplierList" @change="changeCascader" clearable
                    :show-all-levels="false" filterable></el-cascader>
            </a-form-item>
            <a-form-item label="项目消费日期">
                <a-range-picker @change="onChangeTime2" v-model="times" :allowClear="false" value-format="yyyy/MM/DD" />
            </a-form-item>
            <a-form-item label="是否已发预订单">
                <a-select v-model="dataForm.is_yuding" placeholder="可选择" style="width: 120px;" allowClear>
                    <a-select-option value="1">是</a-select-option>
                    <a-select-option value="2">否</a-select-option>
                </a-select>
            </a-form-item>
            <a-form-item label="是否已给供应商结算">
                <a-select v-model="dataForm.is_jiesuan" placeholder="可选择" style="width: 120px;" allowClear>
                    <a-select-option value="1">是</a-select-option>
                    <a-select-option value="2">否</a-select-option>
                </a-select>
            </a-form-item>
            <a-form-item>
                <a-button type="primary" @click="getDataList" :loading="dataListLoading">搜索</a-button>
            </a-form-item>
            <a-form-item>
                <a-button type="primary" @click="exportHandle" :loading="dataListLoading || exportLoading">导出</a-button>
            </a-form-item>
            <a-form-item>
                <a-button type="primary" @click="batchHandle" :disabled="selectedRowKeys.length == 0">批量修改</a-button>
            </a-form-item>
        </a-form>
        <a-table :columns="columns" :data-source="dataList" :pagination="false" rowKey="tripproject_id"
            :loading="dataListLoading" :scroll="{ x: 2460 }"
            :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }">
            <template slot="days" slot-scope="days, row">
                <span v-if="row.days_project == 1">{{ days }}</span>
                {{ row.days_unit }}
                <a-tag class="ml-10" :color="row.days_project == 1 ? 'green' : 'blue'">{{
                    row.days_project == 1 ? "参与价格计算" : "不参与价格计算"
                }}</a-tag>
            </template>
            <template slot="editBtn" slot-scope="text, row">
                <a type="link" class="btn-edit" v-permission="['admin:tripproject:update']"
                    @click="addOrUpdateHandle(row.trip_id, row.tripproject_id)">
                    编辑项目
                </a>
            </template>
            <template slot="trip" slot-scope="trip, row">
                <div>
                    <a-tooltip>
                        <template slot="title">
                            {{ row.project_name }}
                        </template>
                        <div class="textover textover1">
                            {{ row.project_name }}
                        </div>
                    </a-tooltip>
                </div>
                <a-tooltip>
                    <template slot="title">
                        行程：{{ trip.trip_name }}
                    </template>
                    <div class="textover textover1"><a style="font-size: 12px;" type="link"
                            @click="detail(trip.trip_id)">行程：{{
                                trip.trip_name }}</a>
                    </div>
                </a-tooltip>

                <div><a style="font-size: 12px;" type="link">客户姓名：{{ trip.customerinfo.customer_name }}</a></div>
                <div>
                    <a-tag v-if="row.process_status == 1" plain color="blue" style="font-size: 12px;">收款审核中</a-tag>
                    <a-tag v-if="row.process_status == 2" plain color="green" style="font-size: 12px;">收款审核已通过</a-tag>
                    <a-tooltip v-if="row.process_status == 3">
                        <template slot="title">
                            {{ row.process_reason }}
                        </template>
                        <a-tag color="red" style="font-size: 12px;">
                            审核被拒绝：({{ row.process_reason }})
                        </a-tag>
                    </a-tooltip>
                </div>
            </template>
            <template slot="is_jiesuan" slot-scope="trip, row">
                <div>预订单：<a-tag :color="row.is_yuding === '1' ? 'green' : row.is_yuding === '2' ? 'red' : ''">{{
                    row.is_yuding === '1' ? '已发' : row.is_yuding === '2' ? '未发' : '未知参数' }}</a-tag></div>
                <div>供应商结算：<a-tag :color="row.is_jiesuan === '1' ? 'green' : row.is_jiesuan === '2' ? 'red' : ''">{{
                    row.is_jiesuan === '1' ? '已结算' : row.is_jiesuan === '2' ? '未结算' : '未知参数' }}</a-tag></div>
            </template>
            <template slot="footer">
                <a-row type="flex">
                    <a-statistic title="预估总成本：" :value="cost_total_all" suffix="元" style="margin-right: 60px;" />
                    <a-statistic title="预估总利润：" :value="profit_total_all" suffix="元" style="margin-right: 60px;" />
                    <!-- <a-statistic title="利润额外费用：" :value="other_expenses" suffix="元" style="margin-right: 60px;" /> -->
                    <!-- <a-statistic title="实际总利润：" :value="profit_total_all" suffix="元" style="margin-right: 60px;" /> -->
                    <a-statistic title="合计售卖价格" :value="price_total_all" suffix="元" style="margin-right: 60px;" />
                    <a-statistic title="项目消费次数（根据项目设置消费日期统计）" :value="cishu" suffix="次" />
                </a-row>
            </template>
        </a-table>
        <a-pagination class="mt-20 float-right" show-size-changer :current="page" :total="total"
            :show-total="(total) => `共 ${total} 条数据`" @showSizeChange="showSizeChange"
            @change="pageCurrentChangeHandle" />
        <addorupdate ref="addOrUpdate" @ok="getDataList"></addorupdate>
        <TripProject ref="tripProject"></TripProject>
        <Piliang ref="piliang" @ok="getDataList"></Piliang>
    </a-card>
</template>

<script>
import viewModule from "@/mixins/view-module";
import TripProject from "@/components/TripProject/index.vue";
import Addorupdate from "@/components/TripProject/addorupdate.vue";
import Piliang from "./piliang.vue";
// 获取当前月的第一天和最后一天
const now = new Date();
const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0);

// 格式化日期为 yyyy/MM/DD
const formatDate = (date) => {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}/${month}/${day}`;
};
const basestart = formatDate(firstDay);
const baselast = formatDate(lastDay);

import moment from "moment";
const today_start = moment().format('YYYY-MM-DD 00:00:00')
const today_end = moment().format('YYYY-MM-DD 23:59:59')
export default {
    mixins: [viewModule],
    components: {
        TripProject,
        Addorupdate,
        Piliang
    },
    props: {
        customer_id: String,
    },
    data() {

        return {
            selectedRowKeys: [],
            supplierList: [],
            mixinViewModuleOptions: {
                getDataListURL: "/admin/finance/projectFinance",
                exportURL: '/admin/finance/exportProjectDetail'
            },
            times: [basestart, baselast],
            dataForm: {
                project_start: basestart,
                project_end: baselast,
                project_name: '',
                customer_name: "",
                process_status: undefined,
                supplier_id: null,
                categorize_id: null,
                goods_id: null,
                is_yuding: undefined,
                is_jiesuan: undefined
            },
            columns: [
                {
                    title: "项目名称",
                    dataIndex: "trip",
                    scopedSlots: { customRender: "trip" },
                    width: 250,
                    // ellipsis: true,
                    fixed: 'left',
                    // align: 'center'
                },
                {
                    title: "项目描述",
                    dataIndex: "is_jiesuan",
                    width: 160,
                    scopedSlots: { customRender: "is_jiesuan" },
                },
                // {
                //     title: "项目名称",
                //     dataIndex: "project_name",
                //     scopedSlots: { customRender: "project_name" },
                //     width: 180,
                //     ellipsis: true,
                //     fixed: 'left',
                //     // align: 'center'
                // },
                {
                    title: "供应商",
                    dataIndex: "goods.supplier.supplier_name",
                    width: 200,
                    ellipsis: true,
                    // fixed: 'left',
                    // align: 'center'
                },
                {
                    title: "售卖单价(元)",
                    dataIndex: "project_price",
                    width: 120,
                },
                {
                    title: "数量",
                    dataIndex: "project_num",
                    width: 80,
                },
                {
                    title: "计价数量",
                    dataIndex: "days",
                    scopedSlots: { customRender: "days" },
                    width: 120,
                },
                {
                    title: "定金",
                    dataIndex: "deposit",
                    width: 100,
                },
                {
                    title: "尾款",
                    dataIndex: "arrears",
                    width: 100,
                },
                {
                    title: "项目消费日期",
                    dataIndex: "tripprojectdaysChildren",
                    width: 140,
                    customRender: (text) => text.map(v => v.day).join('、'),
                    // ellipsis: true,
                },
                {
                    title: "项目旁白",
                    dataIndex: "project_remark",
                    // scopedSlots: { customRender: "project_remark" },
                    // customRender: (text) => (text ? text : "无"),
                    ellipsis: true,
                    width: 200,
                },
                {
                    title: "项目备注",
                    dataIndex: "project_remark2",
                    // scopedSlots: { customRender: "project_remark" },
                    // customRender: (text) => (text ? text : "无"),
                    ellipsis: true,
                    width: 300,
                },
                {
                    title: "项目创建时间",
                    dataIndex: "create_time",
                    width: 200,
                },
                {
                    title: "合计成本",
                    dataIndex: "cost_total",
                    width: 100,
                    fixed: "right",
                },
                {
                    title: "合计利润",
                    dataIndex: "profit_total",
                    width: 100,
                    fixed: "right",
                },
                {
                    title: "合计售卖",
                    dataIndex: "price_total",
                    width: 100,
                    fixed: "right",
                },
                {
                    title: "操作",
                    scopedSlots: { customRender: "editBtn" },
                    width: 190,
                    fixed: "right",
                },
            ],
            cost_total_all: "",//预估总成本
            profit_total_all: "",//预估总利润
            other_expenses: "",//利润额外费用
            profit_total_all: "",//实际总利润
            price_total_all: "",//合计售卖
            cishu: ""
        };
    },
    mounted() {
        this.getSupplierList()
        // 初始化时设置时间范围
        if (this.times && this.times.length === 2) {
            this.dataForm.project_start = `${this.times[0]} 00:00:00`;
            this.dataForm.project_end = `${this.times[1]} 23:59:59`;
        }
    },
    methods: {
        onSelectChange(selectedRowKeys) {
            this.selectedRowKeys = selectedRowKeys;
        },
        batchHandle() {
            console.log(this.selectedRowKeys)
            this.$refs.piliang.init(this.selectedRowKeys)
        },
        queryAfter(e) {
            this.cost_total_all = e.data.cost_total_all
            this.profit_total_all = e.data.profit_total_all
            this.other_expenses = e.data.other_expenses
            this.profit_total_all = e.data.profit_total_all
            this.price_total_all = e.data.price_total_all
            this.cishu = e.data.cishu
        },
        onChangeTime2(e) {
            if (e.length == 2) {
                this.dataForm.project_start = `${e[0]} 00:00:00`
                this.dataForm.project_end = `${e[1]} 23:59:59`
            } else {
                this.dataForm.project_start = undefined
                this.dataForm.project_end = undefined
            }
        },
        changeCascader(e) {
            this.dataForm.supplier_id = e[0] || null
            this.dataForm.categorize_id = e[1] || null
            this.dataForm.goods_id = e[2] || null
        },
        getSupplierList() {
            this.$http({
                url: "/admin/supplier/goodsChildren",
                method: "get",
            }).then((res) => {
                this.supplierList = res.data;
            });
        },
        addOrUpdateHandle(trip_id, tripproject_id) {
            this.$refs.addOrUpdate.init(trip_id, tripproject_id);
        },
        TripProjectClick(trip_id) {
            this.$refs.tripProject.init(trip_id);
        },
        filterOption(input, option) {
            return (
                option.componentOptions.children[0].text
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
            );
        },
        //行程信息
        detail(trip_id) {
            this.$refs.tripProject.init(trip_id);
        },
    },
};
</script>

<style></style>